import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'
import Permissions from 'Components/Permissions'

import { FAMILY_ALBUM_URL } from 'Global/constants'

const FAPictureCardActions = ({ picture }) => {
  return (
    <Card.Content extra>
      <List>
        <CardProperty href={`${FAMILY_ALBUM_URL}/${picture.edited}`} icon="download" popUpContent="Download Polaroid" download>
          Polaroid (JPG)
        </CardProperty>

        {picture.original ? (
          <Permissions
            permissions="familyAlbum.downloadOriginalPicture"
            render={() => (
              <CardProperty href={`${FAMILY_ALBUM_URL}/${picture.original}`} icon="download" popUpContent="Download Original" download>
                Original (JPG)
              </CardProperty>
            )}
          />
        ) : null}
      </List>
    </Card.Content>
  )
}

FAPictureCardActions.propTypes = {
  picture: PropTypes.object.isRequired,
}

export default FAPictureCardActions
